<template>
  <v-content class="pa-0">
    <v-card-title class="grey lighten-3">
      <v-row>
        <v-icon class="draggable">mdi-drag</v-icon>
        <v-col class="py-0">{{ starLabel }}</v-col>
      </v-row>
    </v-card-title>
    <v-card-text class="pa-3">
      <v-container fluid grid-list-md class="pa-0">
        <v-layout row wrap>
          <v-flex sm6>
            <v-text-field
              label="Name"
              v-model="sr.name"
              @input="$v.sr.name.$touch()"
              @blur="$v.sr.name.$touch()"
              :error-messages="nameErrors"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
          <v-flex sm6>
            <v-text-field
              label="Number"
              type="number"
              v-model="sr.number"
              @input="$v.sr.number.$touch()"
              @blur="$v.sr.number.$touch()"
              :error-messages="numberErrors"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-row>
          <v-col>
            <v-switch
              v-model="sr.notInUse"
              label="Not In Use"
              :outlined="outlinedInputs"
            ></v-switch>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-content>
</template>

<script>
import {
  STAR_CREATE_MUTATION,
  STAR_UPDATE_MUTATION,
} from "../../../../constants/graphql";
import { required } from "vuelidate/lib/validators";

export default {
  name: "StarEditor",

  props: {
    star: {
      type: Object,
      default: () => ({}),
    },

    doSaveStar: {
      type: Boolean,
      default: false,
    },

    starEditorDialog: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      sr: { ...this.star },
      debug: false,
    };
  },

  methods: {
    saveStar() {
      this.$emit("onResetSave");
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let mutation =
          this.context == "edit" ? STAR_UPDATE_MUTATION : STAR_CREATE_MUTATION;
        this.$apollo
          .mutate({
            mutation: mutation,
            variables: {
              name: this.sr.name,
              number: Number(this.sr.number),
              notInUse: this.sr.notInUse,
              id: this.sr.id,
            },
          })
          .then(this.saveGqlObjectHandler, this.saveGqlObjectErrorHandler);
      }
    },
    saveGqlObjectHandler(result) {
      this.$emit("saved", this.context);
    },
    saveGqlObjectErrorHandler(err) {
      console.log(err);
    },
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    starLabel() {
      return this.star.id != null ? this.star.name : "New Star Rating";
    },
    context() {
      return this.star.id != null ? "edit" : "create";
    },
    nameErrors() {
      let errors = [];
      if (!this.$v.sr.name.$dirty) {
        return errors;
      }
      if (!this.$v.sr.name.required) {
        errors.push("Name is required.");
      }
      return errors;
    },
    numberErrors() {
      let errors = [];
      if (!this.$v.sr.number.$dirty) {
        return errors;
      }
      if (!this.$v.sr.number.required) {
        errors.push("Number is required.");
      }
      return errors;
    },
  },

  watch: {
    star(data) {
      let star = { ...data };
      delete star.__typename;
      this.sr = star;
    },
    starEditorDialog(value) {
      if (!value) {
        this.sr = {};
        this.$v.$reset();
      }
    },
    doSaveStar(value) {
      if (value) {
        this.saveStar();
      }
    },
  },
  validations: {
    sr: {
      name: { required },
      number: { required },
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/admin/service-types/StarEditor.vue